import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import { checkUserClaims } from 'shared/auth';
import { UserClaims } from 'shared/mechanics/auth';
import { PropsWithClassName } from 'shared/props';
import styles from './content-panel.module.scss';

export interface ContentPanelProps extends PropsWithClassName {
	title: string | ReactNode;
	children: ReactNode;
	anchor?: string;
	help?: {
		href?: string;
	};
	defaults?: {
		isExpanded?: boolean;
	};
	expandPermissions?: {
		claim: UserClaims;
		title: string;
	}
}
export const ContentPanel = (props: ContentPanelProps) => {
	const { isExpanded: defaultIsExpanded = true } = props.defaults || { };

	const [isExpanded, setIsExpanded] = useState<boolean>(defaultIsExpanded);

	const helpHref = props.help?.href;

	function onExpandClick() {
		if (props.defaults?.isExpanded !== false) {
			setIsExpanded(!isExpanded);
		}
		else if (props.expandPermissions) {
			checkUserClaims(props.expandPermissions.claim, props.expandPermissions.title, () => {
				setIsExpanded(!isExpanded);
			})
		}
		else {
			setIsExpanded(!isExpanded);
		}
	}

	return (
		<div className={classNames(styles.container, isExpanded ? styles.expanded : styles.collapsed, props.className)} id={props.anchor}>
			<div className={classNames(styles.header)} onClick={() => onExpandClick()}>
				<h2>{ props.title }</h2>
				{
					helpHref
						? <a href={helpHref} target="_blank"><i className={classNames("far fa-question-circle", styles.manage)}></i></a>
						: null
				}
				
				<i className={classNames("fas", isExpanded ? "fa-chevron-up" : "fa-chevron-down", styles.manage)}></i>
			</div>
			{
				isExpanded
					? (
						<div className={styles.content}>
							{ props.children }
						</div>
					)
					: null
			}
		</div>
	);
}
